import React from 'react';
import IdleTimer from 'react-idle-timer';
import { API_HEADERS, API_URL } from '../../../constants/api';
import { apiRequestNoLoadder } from '../../../utils/api_service';
import { getLastFetchedSPSTokenData, setSPSToken } from '../../../constants/appConstants';
import moment from 'moment';
import { ShowToast, toastType } from '../../../utils/toast-service';
let callGetAfterCount = 0;
const IDLE_TIME = 45 * 60 * 1000;

export default function IdleSessionTimer() {
  
  function onIdle () {
    //console.log('Idle - relogin in process')    
    ShowToast("Your session has expired due to inactivity. Please refresh the page to continue.", toastType.WARNING, false, 500);
  }

  return (
    <IdleTimer
      element={document}
      onIdle={onIdle}
      onAction={() => { }}
      debounce={250}
      timeout={IDLE_TIME} // After 45 minutes it will show idle message
    />
  );
}
